/**
 * SearchResultCard — 搜索结果卡片组件
 */

import { MapPin, Star, Tag } from 'lucide-react';
import type { PoiSearchDoc, HotelSearchDoc } from '@/infrastructure/api/search';

interface SearchResultCardProps {
  type: 'poi' | 'hotel' | 'attraction' | 'guide';
  data: PoiSearchDoc | HotelSearchDoc;
  onClick?: () => void;
}

export const SearchResultCard = ({ type, data, onClick }: SearchResultCardProps) => {
  const isHotel = type === 'hotel';
  const hotel = data as HotelSearchDoc;
  const poi = data as PoiSearchDoc;

  return (
    <div
      onClick={onClick}
      className="p-4 rounded-xl bg-white shadow-sm border border-gray-50 hover:shadow-md hover:border-primary/20 transition-all cursor-pointer"
    >
      <div className="flex items-start gap-3">
        {/* 图标 */}
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary/10 to-primary/5 flex items-center justify-center flex-shrink-0">
          {isHotel ? (
            <span className="text-lg">🏨</span>
          ) : (
            <MapPin className="w-5 h-5 text-primary" />
          )}
        </div>

        {/* 内容 */}
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-text-primary truncate">
            {isHotel ? hotel.name : poi.name}
          </h4>

          <div className="flex items-center gap-2 mt-1">
            {(data as any).rating && (
              <span className="flex items-center gap-0.5 text-xs text-amber-500">
                <Star className="w-3 h-3 fill-current" />
                {(data as any).rating}
              </span>
            )}
            {isHotel && hotel.starLevel && (
              <span className="text-xs text-gray-400">
                {'★'.repeat(hotel.starLevel)}
              </span>
            )}
            {poi.category && (
              <span className="text-xs px-1.5 py-0.5 rounded bg-gray-50 text-gray-500">
                {poi.category}
              </span>
            )}
          </div>

          <p className="text-xs text-gray-400 mt-1 truncate">
            {data.address}
          </p>

          {poi.tags && poi.tags.length > 0 && (
            <div className="flex items-center gap-1 mt-2 flex-wrap">
              {poi.tags.slice(0, 3).map((tag, i) => (
                <span key={i} className="flex items-center gap-0.5 text-xs text-gray-400">
                  <Tag className="w-2.5 h-2.5" />
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResultCard;
